export default class BannerInfo {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {}
}
